import React from 'react'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import './TopQuestionsDataRangeSelect.scss'
import { useDispatch, useSelector } from 'react-redux'
import { Dayjs } from 'dayjs'
import { fromDayJsObject, toDayJsObject } from 'tabs/topQuestions/utils/DateUtils'
import { lineChartFilterEndDateChange, lineChartFilterStartDateChange } from 'tabs/topQuestions/lib/question_clustering_status/questionClusteringStatusActions'
import { selectEndDateFilter, selectStartDateFilter } from 'tabs/topQuestions/lib/question_clustering_status/questionClusteringStatusSelectors'


export const TopQuestionsDataRangeSelect: React.FC = () => {
  const dispatch = useDispatch()
  const selectedStartDate = useSelector(selectStartDateFilter)
  const selectedEndDate = useSelector(selectEndDateFilter)

  const startValue = toDayJsObject(selectedStartDate)
  const endValue = toDayJsObject(selectedEndDate)


  const onStartDateChange = (day: Dayjs | null) => {
    const dateObj = fromDayJsObject(day)
    dispatch(lineChartFilterStartDateChange(dateObj))
  }

  const onEndDateChange = (day: Dayjs | null) => {
    const endObj = fromDayJsObject(day)
    dispatch(lineChartFilterEndDateChange(endObj))
  }

  return <LocalizationProvider dateAdapter={AdapterDayjs}>
    <div className={'topQuestionsDateRangeWrapper'}>
      <DatePicker label="Start date" value={startValue} onChange={onStartDateChange} />
      <div className={'topQuestionsDateDash'} />
      <DatePicker label="End date" value={endValue} onChange={onEndDateChange} />
    </div>
  </LocalizationProvider>
}
